<div class="tile-container-skeleton" *ngIf="loadingData">
  <div fxLayoutAlign="center">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
<div class="tile-container" fxLayout="column" [ngClass]="{ hide: loadingData }">
  <div fxLayout="row" [ngClass]="{ hide: loadingData }" fxLayoutAlign="space-between">
    <div fxLayout="column" class="tile-header" fxFlex="35%">
      Time of Day <span class="subtitle">(Top 6 Affiliates)</span>
    </div>
    <div fxLayout="column" fxFlex="30%" *ngIf="!loadingData">
      <mat-form-field appearance="outline">
        <mat-label>Time of Day</mat-label>
        <mat-select
          [(ngModel)]="selectedTimeOfDay"
          [ngModelOptions]="{ standalone: true }"
          (selectionChange)="changeSelectedTimeOfDay($event)"
        >
          <mat-option *ngFor="let opt of timeOfDayOptions" [value]="opt.value">
            {{ opt.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div fxLayout="row" style="margin-bottom: 15px" id="tod-activity-legend" [ngClass]="{ hide: loadingData }"></div>
  <div fxLayout="row" fxLayout.lt-md="column" fxLayout.lt-sm="column" fxFlex="100%">
<!--    <div fxLayout="column" fxFlex="23%">-->
<!--      <div fxLayout="row" fxLayoutGap="5%" class="tile-subheader-container">-->
<!--        <div fxLayout="column" class="tile-subheader">-->
<!--          Activity by Affiliate-->
<!--        </div>-->
<!--        <div fxLayout="column">-->
<!--          <mat-radio-group-->
<!--            fxLayout="column"-->
<!--            fxLayoutGap="10px"-->
<!--            [(ngModel)]="activityDisplayField"-->
<!--            (change)="changeActivityDisplayValue($event)"-->
<!--          >-->
<!--            <mat-radio-button value="sessions" fxLayout="row">Sessions</mat-radio-button>-->
<!--            <mat-radio-button value="pageviews" fxLayout="row">Pages visited</mat-radio-button>-->
<!--          </mat-radio-group>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div fxLayout="row">-->
<!--        <div class="chart-container" *ngIf="!loadingData">-->
<!--          <x-chartist-->
<!--            [type]="'Bar'"-->
<!--            class="chart"-->
<!--            [data]="activityChartData"-->
<!--            [options]="activityChartOpts"-->
<!--            [events]="activityChartEvents"-->
<!--          ></x-chartist>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <mat-divider [vertical]="true"></mat-divider>-->
    <!--lift chart-->
    <div fxLayout="column" fxFlex="76%">
      <div fxLayout="row" class="tile-subheader-container">
        <div fxLayout="column" class="tile-subheader" style="padding-left: 5%">
          Average Lift by Affiliate
        </div>
      </div>
      <div fxFlex="100%">
        <div class="chart-container" *ngIf="!loadingData">
<!--          <x-chartist-->
<!--            id="tod-lift-chart"-->
<!--            [type]="'Bar'"-->
<!--            class="chart"-->
<!--            [data]="liftChartData"-->
<!--            [options]="liftChartOpts"-->
<!--            [events]="liftChartEvents"-->
<!--            (initialized)="chartInitialized($event)"-->
<!--          ></x-chartist>-->
        </div>
      </div>
    </div>
    <mat-divider [vertical]="true"></mat-divider>
    <div fxLayout="column" fxFlex="23%">
      <div fxLayout="row" class="tile-subheader-container">
        <div fxLayout="column" style="padding-left: 5%">
          <div class="tile-subheader">Length</div>
          <div fxLayout="column" id="tod-length-legend" [ngClass]="{ hide: loadingData }"></div>
        </div>
        <div fxLayout="column">
          <mat-radio-group
            fxLayout="column"
            fxLayoutGap="10px"
            [(ngModel)]="lengthDisplayField"
            (change)="changeLengthDisplayValue($event)"
          >
            <mat-radio-button value="sessions" fxLayout="row">Sessions</mat-radio-button>
            <mat-radio-button value="lift" fxLayout="row">Lift</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="chart-container" *ngIf="!loadingData">
<!--        <x-chartist-->
<!--          id="tod-length-chart"-->
<!--          [type]="'Pie'"-->
<!--          class="chart"-->
<!--          [data]="lengthChartData"-->
<!--          [options]="lengthChartOpts"-->
<!--          [events]="{}"-->
<!--          (initialized)="chartInitialized($event)"-->
<!--        ></x-chartist>-->
      </div>
    </div>
  </div>
</div>
